import { IconProps, iconA11yProps } from '../types';

export const Stop = ({ classNames, label }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 18" className={classNames} {...iconA11yProps(label)}>
        <rect y="1" width="16" height="16" rx="1" ry="1" />
    </svg>
);
